import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import SaveIcon from "@material-ui/icons/Save";
import InfoIcon from "@material-ui/icons/Info";
import EditIcon from "@material-ui/icons/Edit";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import MoreVertIcon from "@material-ui/icons/MoreVert";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import Dialog from "../gui/Dialog";
import EditIcons from "./EditIcons";
import ViewTypeButtons from "./ViewTypeButtons";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0
  },
  menuButton: {
    marginRight: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  },
  title: {
    flexGrow: 1
  },
  separator: {
    borderLeft: "1px solid white",
    height: theme.spacing(4),
    marginRight: theme.spacing(3)
  }
}));

export default function MolstackAppBar(props) {
  const classes = useStyles();
  const [showInfo, setShowInfo] = useState(false);
  // const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const settingsOpen = Boolean(settingsAnchorEl);

  function handleMenuClick(event) {
    setSettingsAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setSettingsAnchorEl(null);
  }

  function handleViewType(event, newType) {
    if (newType) props.onViewTypeChange(newType);
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={props.onMenu}
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="Back"
            onClick={props.onBack}
          >
            <ArrowBackIcon />
          </IconButton>
          <EditIcons classes={classes} {...props} />
          {props.info.description && (
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Description"
              onClick={() => setShowInfo(true)}
            >
              <InfoIcon />
            </IconButton>
          )}
          <Typography variant="h6" className={classes.title}>
            {props.info.title}
          </Typography>
          <ViewTypeButtons
            viewType={props.viewType}
            onChange={handleViewType}
          />
        </Toolbar>
      </AppBar>
      {props.info.description && (
        <Dialog
          open={showInfo}
          onClose={() => setShowInfo(false)}
          title={props.info.title}
          message={props.info.description}
        />
      )}
    </div>
  );
}
